export default {

	country: 'en',

    config: {},

    response: {dhlEmployee:0, country:'gb'},//, flashCode:"X", flashGiveaway:"0"},

    baseUrl: null,

    div: null,

    isIE: false,

    isAndroid: false,

    isKindle: false,

    isMac: false,

    isFirefox: false,

    isEdge: false,

    currentQuestion: 0,

    seatNumber: 0,

    soundManager: null,
    
    boardGraphicGenerator: null,

    introVideoFinished: false,

    basicMode: false,

    basicButton: null,

    muteButton: null,

    videoPlaying: false
}